export const _en = {
    addButton: {
        label: "Add location"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add a location"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Site"
    },
    toggleDeleted: {
        label: "Afficher les sites archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un site"
        }
    }
};